import { useEffect, useState } from "react";
import axios from "axios";
import { useSearchParams } from "react-router-dom";
import {
  Button,
  HStack,
  Spinner,
  Text,
  Icon,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaMicrosoft } from "react-icons/fa";


const MicrosoftAuth = () => {
  const [searchParams] = useSearchParams();
  const code = searchParams.get("code");

  const [loading, setLoading] = useState(false);
  const [user, setUser] = useState<any>(null);

  const clientId = "15794963-72a3-4ad7-8602-1c3a20807ed7";
  const tenantId = "5c1f1620-2fa8-46e0-b7f6-be5a8531bf36";
  const redirectUri = `${process.env.REACT_APP_FRONTEND_URL}/auth/callback`;

  const handleLogin = () => {
    const url = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?client_id=${clientId}&response_type=code&redirect_uri=${redirectUri}&response_mode=query&scope=openid profile email offline_access`;
    window.location.href = url;
  };

  useEffect(() => {
    if (code && !user) {
      setLoading(true);
      axios
        .post(`${process.env.REACT_APP_BACKEND_URL}/auth/microsoft`, { code })
        .then((res: any) => {
          if (res?.status === "success") {
            setUser(res.data.user);
            sessionStorage.setItem("token", res.token);
          }
        })
        .catch((err: any) => console.error("Microsoft login error:", err))
        .finally(() => setLoading(false));
    }
  }, [code, user]);

  // 🌗 Adaptive colors for light/dark mode
  const borderColor = useColorModeValue("gray.300", "gray.600");
  const hoverBg = useColorModeValue("gray.50", "gray.700");
  const successBg = useColorModeValue("green.50", "green.900");
  const successColor = useColorModeValue("green.600", "green.300");
  const buttonBg = useColorModeValue("white", "gray.800"); // ✅ hook at top level

  if (loading) {
    return (
      <Button
        w="full"
        variant="outline"
        borderColor={borderColor}
        isDisabled
        leftIcon={<Spinner size="sm" />}
        _disabled={{
          opacity: 0.8,
          cursor: "not-allowed",
        }}
      >
        Logging in...
      </Button>
    );
  }

  if (user) {
    return (
      <HStack
        w="full"
        p={4}
        border="1px solid"
        borderColor="green.300"
        bg={successBg}
        rounded="lg"
        justify="center"
        spacing={2}
        shadow="sm"
      >
        <Icon as={FaMicrosoft} color="green.500" boxSize={5} />
        <Text color={successColor} fontWeight="600" fontSize="sm">
          ✅ Signed in as{" "}
          <Text as="span">{user.displayName || user.name}</Text>
        </Text>
      </HStack>
    );
  }

  return (
    <Button
      w="full"
      variant="outline"
      borderColor={borderColor}
      onClick={handleLogin}
      leftIcon={<FaMicrosoft />}
      rounded="lg"
      fontWeight="500"
      fontSize="sm"
      py={5}
      bg={buttonBg} // ✅ using variable
      _hover={{
        bg: hoverBg,
        transform: "translateY(-1px)",
        boxShadow: "md",
      }}
      _active={{ transform: "translateY(0px)" }}
      transition="all 0.2s ease-in-out"
    >
      Sign in with Microsoft
    </Button>
  );
};

export default MicrosoftAuth;
